<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                     <h3>Seja bem vindo(a) {{usuarioLogado.nome}}!</h3>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuarioLogado.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
           <b-form>
               <b-row>
                 <b-col cols="12">
                     <h3>Beneficiárias Acompanhadas</h3>
                 </b-col>
              </b-row>
                   <br>
                   <b-row>
                        <b-col v-for="bene in minhasBeneficiarias" :key="bene.id" sm="6" lg="3">
                          <b-card>
                            <div class="h4 m-0">
                                <span v-if="bene.nome.length > 30" v-b-tooltip.hover :title="bene.nome">
                                     {{bene.nome.substring(0, 15)}}...
                                </span>
                                <span v-else v-b-tooltip.hover :title="bene.nome">
                                     {{bene.nome}}
                                </span>
                            </div>
                            <b-progress height={} class="progress-xs my-3" variant="success" :value="25"/>
                            <small class="text-muted action" @click="navigate('/beneficiaria/' + bene.id + '/visualizar')">Visualizar Beneficiária e atendimentos.</small>
                          </b-card>
                        </b-col>
                   </b-row><!--/.row-->
          </b-form>
        </b-card-body>
      </b-card>
    </span>
</template>

<script>
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'
import Vue from 'vue'

miniToastr.init()

export default {
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'V') {
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      minhasBeneficiarias: [],
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      usuarioCorrente: parseInt(SessionStorage.get('usuario'))
    }
  },
  computed: {
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.perfil': function () {
      this.usuarioLogado.nome = this.usuario.nome
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    },
    'usuario': function () {
      this.verificarCapacidade()
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    navigate (route) {
      this.$router.push(route)
    },
    verificarCapacidade () {
      Vue.http.post('api/voluntario/minhasBeneficiarias', {usuario_id: this.usuario.id}).then(response => {
        if (response.data.success) {
          this.minhasBeneficiarias = response.data.data.minhasBeneficiarias
        }
      })
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/MinhasBeneficiarias.vue